<template>
  <div
    class="detail_main">
    <div @click="$parent.show = false" class="detail_container"
     :class="{'bg_detail': bg}">
    </div>
      <section
        class="size_detail
          zero_right
          margin_top_detail
          padding_bottom_detail
          has-background-white
          is-scrollable">
        <div class="columns is-marginless detail_content detail_content_bg">
          <div class="half_width detail_img_info">
            <a class="button has-text-white is-rounded diapo_button"
              :class="{'is-primary': hoverButton}"
              @click="show = true"
              @mouseover.prevent="hoverButton = true"
              @mouseout.prevent="hoverButton = false">
              <span class="icon">
                <b-icon
                  icon="image-multiple"
                  size="is-label">
                </b-icon>
              </span>
              <p class="p_size14">Voir diaporama</p>
            </a>
            <img :src="url" class="imageBgOpp imgGoToTop">
          </div>
          <div class="half_width topVert leftVert rightVert">
            <a @click="$parent.show = false"
              class="detail_icon_close_right">
              <b-icon
                icon="window-close"
                size="">
              </b-icon>
            </a>
            <h3 class="has-text-weight-bold has-text-link bottomViolet">
              Proposition:</h3>
            <div class="column bottomViolet color-icon is-paddingless"
                 v-if="detailReseauxPerso.dateDebut">
              <div class="media">
                <b-icon
                  icon="timer"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">
                    Période d'affichage
                  </label><br>
                  <p class="p_size14 has-text-weight-bold has-text-link">
                    {{date(detailReseauxPerso.dateDebut) + ' au ' +
                      date(detailReseauxPerso.dateFin)}}
                  </p>
                </div>
              </div>
            </div>
            <div class="columns is-marginless is-multiline color-icon detail_content_propo">
              <div
                v-if="detailReseauxPerso.tarifHT"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="cash"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Tarif Brut HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{calTarif(detailReseauxPerso.tarifHT)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailReseauxPerso.tarifNet"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="cash"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Tarif Net HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{calTarif(detailReseauxPerso.tarifNet)}}
                    </p>
                    <span class="has-text-grey is-italic"
                      v-if="detailReseauxPerso.masquerRemiseEdition === true
                        && this.detailReseauxPerso.remise">
                      {{this.detailReseauxPerso.remise}} {{typeRemise}}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="detailReseauxPerso.tarifImpression"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="printer"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Tarif d'impression HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailReseauxPerso.tarifImpression)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailReseauxPerso.taxeMunicipale"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="ballot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Taxes municipales
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailReseauxPerso.taxeMunicipale)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailReseauxPerso.tarifDePose"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Tarif de pose HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailReseauxPerso.tarifDePose)}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="detailReseauxPerso.commentaire">
              <h3 class="has-text-weight-bold topViolet has-text-link">
                Commentaire:</h3>
              <div class="">
                <p class="has-text-link has-text-justify p_size14 mb-btnaction">
                  {{detailReseauxPerso.commentaire}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-marginless is-block detail_content_2">
          <div class="column leftVert topVert rightVert is-paddingless">
            <h3 class="has-text-weight-bold bottomVert has-text-link">
              Caractéristiques:</h3>
            <div class="columns is-multiline color-icon">
              <div class="column" v-if="detailReseauxPerso.libelle">
                <div class="media">
                  <div class="media-content is-size-7">
                    <p class="is-size-7 bottomViolet">
                     <label class="has-text-default">
                       Nom du réseau
                      </label><br>
                      <strong class="p_size14 has-text-link">
                        {{detailReseauxPerso.libelle}}
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Nombre de faces
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxPerso.nbFaces}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column topRouge bottomVert is-4 is-offset-8">
            <div v-if="!detailReseauxPerso.select" @click="contolSelect()">
              <a class="button is-primary is-rounded t14 rightVert">Ajouter à ma sélection</a>
            </div>
            <div v-else @click="contolSelect()">
              <a class="button boutonRed has-text-white is-rounded t14 rightVert">
                Retirer de ma sélection</a>
            </div>
          </div>
        </div>
      </section>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="1000">
        <app-diapo-personnalise
        :detailPerso="detailReseauxPerso.faces"
        :reseau="detailReseauxPerso.libelle"
        v-if="show"/>
      </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { urlPhoto, formatNum, formatDateExplicite } from '@/services/opportunite/formatTab';
import diapoPersonnalise from './diapoPersonnalise';

export default {
  name: 'detailReseauxPersonnaliseCompletDiapo',
  props: ['detailReseauxPerso', 'bg'],
  data() {
    return {
      show: false,
      hoverButton: false,
    };
  },
  components: {
    appDiapoPersonnalise: diapoPersonnalise,
  },
  computed: {
    url() {
      return urlPhoto(this.detailReseauxPerso.urlPhoto);
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let tarifImpression = 0;
      let tarifHT = 0;
      if (this.infoReseauxPersonnalise.tarifDePose) {
        tarifDePose = this.infoReseauxPersonnalise.tarifDePose;
      }
      if (this.infoReseauxPersonnalise.taxeMunicipale) {
        taxeMunicipale = this.infoReseauxPersonnalise.taxeMunicipale;
      }
      if (this.infoReseauxPersonnalise.tarifImpression) {
        tarifImpression = this.infoReseauxPersonnalise.tarifImpression;
      }
      if (this.infoReseauxPersonnalise.tarifHT) {
        tarifHT = this.infoReseauxPersonnalise.tarifHT;
      }
      if (this.infoReseauxPersonnalise.tarifNet) {
        tarifNet = this.infoReseauxPersonnalise.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
      }
      return tarifHT
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
    },
    typeRemise() {
      if (this.detailReseauxPerso.typeDeRemise === 0) {
        return '% de remise inclus';
      }
      return '€ de remise inclus';
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailReseauxPerso.select = !this.detailReseauxPerso.select;
      if (this.detailReseauxPerso.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    calTarif(t) {
      return formatNum(t);
    },
    close() {
      this.$parent.show = false;
    },
    date(d) {
      return formatDateExplicite(d);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxPersonnalise/detailReseauxPersonnaliseCompletDiapo.vue